import React from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";

const ViewExpanseReport = ({ isData, isLoading }) => {
  const { isUser } = useAuth();
  return (
    <>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">EXPENSE REPORT</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex rtable">
          <div className="w-50">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  {/* <td className="w-25">Name</td> */}
                  {/* <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td> */}
                </tr>
                <tr>
                  <td className="w-25">From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.startdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.startdate,
                          isUser?.timezone
                        )
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.enddate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.enddate,
                          isUser?.timezone
                        )
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">No of Expense</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `${isData?.totalitems || 0}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="w-10"></div>

          {/* <div className="w-50 rtable">
            <table className="table table-sm table-bordered mb-0 text-center">
              <tbody>
                <tr>
                  <td className="w-25 fw-500">Base Total</td>
                  <td className="w-25 fw-500">GST Total</td>
                  <td className="w-25 fw-500">Grand Total</td>
                </tr>
                <tr>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalBasePrice) || 0,
                        "INR"
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalTaxAmount) || 0,
                        "INR"
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.grandTotal) || 0,
                        "INR"
                      )}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> */}
        </div>

        <table className="table table-sm table-bordered mb-3 rtable">
          <tbody>
            <tr>
              <td className="text-center">S No</td>
              <td className="text-center">Expense Date</td>
              <td className="text-center">Title</td>
              <td className="text-center">Description</td> 
              <td className="text-center">PayMode</td>
              <td className="text-center">Amount</td>
              {/* <td className="text-center">status</td> */}
            </tr>
          </tbody>
          <tbody>
            {isLoading ? (
              [...Array(10)].map((_, index) => (
                <tr key={index}>
                  <td className="text-center">
                    <Skeleton variant="text" />
                  </td>
                  <td className="text-center">
                    <Skeleton variant="text" />
                  </td>
                  <td className="text-center">
                    <Skeleton variant="text" />
                  </td>
                  <td className="text-center">
                    <Skeleton variant="center" />
                  </td>
                  <td className="text-center">
                    <Skeleton variant="text" />
                  </td>
                  <td className="text-center">
                    <Skeleton variant="text" />
                  </td>
                  {/* <td className="text-center">
                    <Skeleton variant="text" />
                  </td> */}
                  {/* <td className="text-center">
                    <Skeleton variant="text" />
                  </td>
                  <td className="text-center">
                    <Skeleton variant="text" />
                  </td> */}
                </tr>
              ))
            ) : Array.isArray(isData?.expenseData) &&
              isData?.expenseData?.length > 0 ? (
              isData?.expenseData?.map((item, index) => (
                <tr key={item?.id || index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">
                    {
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item?.expensedate,
                          isUser?.timezone
                        )
                      ).date
                    }
                  </td>
                  <td className="text-center">{item.title}</td>
                  <td className="text-center">{item.description}</td>
                  <td className="text-center">{item.paymode}</td>
                  <td className="text-center">
                    ₹{CurrencyConverter.toCurrency(item?.amount || 0, "INR")}
                  </td>
                  {/* <td className="text-center">{item.status}</td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center p-2">
                  <small className="text-muted">
                    No expense found in the store. add some customers to get
                    started.
                  </small>
                </td>
              </tr>
            )}
          </tbody>
          <tbody>
            <tr>
              <td colSpan="5" className="text-center"></td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.totalexpense || 0,
                    "INR"
                  )}`
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ViewExpanseReport;
